<template>
  <div class="space-y-6">
    <div class="flex">
      <div class="w-1/2 text-sm font-medium text-headline">
        {{ $t("CHECKOUT.DATA_SERVICE") }}
      </div>
      <div class="w-1/2 text-sm font-medium text-headline">
        {{ $t("COMMON.STATUS") }}
      </div>
    </div>
    <div class="rounded border border-gray-200 p-4">
      <div class="flex items-center">
        <div class="w-1/2 text-sm text-headline">
          {{ serviceName }}
        </div>
        <div class="w-1/2">
          <lf-pill class="inline-block uppercase" :color-index="colorIndex">
            {{ statusText }}
          </lf-pill>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { SERVICE_PREVIEW_CONTENT } from "@/helpers/constants/checkout";
import { useCheckoutStore } from "@/stores/checkout";

import LfPill from "@/components/ui/text/LfPill.vue";

import type { CheckoutServiceStep } from "@/models/checkout";

const { step } = defineProps<{
  step: CheckoutServiceStep;
}>();

const { t } = useI18n();
const checkoutTemplateStore = useCheckoutStore();
const { isActiveTemplateStepComplete } = checkoutTemplateStore;

const isComplete = computed(() => isActiveTemplateStepComplete(step.id));

const serviceName = computed(() => {
  if (!step.service_id) {
    return "-";
  }

  const content = SERVICE_PREVIEW_CONTENT[step.service_id];
  if (!content) {
    return step.service_id;
  }

  return t(content.title);
});

const statusText = computed(() =>
  isComplete.value ? t("CHECKOUT.CONNECTED") : t("CHECKOUT.NOT_CONNECTED")
);

const colorIndex = computed(() => (isComplete.value ? 0 : 5));
</script>
